/* eslint-disable */
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import '@fontsource/cormorant-garamond/300.css';
import '@fontsource/cormorant-garamond/300-italic.css';
import '@fontsource/cormorant-garamond/400.css';
import '@fontsource/cormorant-garamond/400-italic.css';
import '@fontsource/cormorant-garamond/600.css';
import '@fontsource/cormorant-garamond/600-italic.css';
import '@fontsource/dm-sans/400.css';
import '@fontsource/dm-sans/500.css';
import '@fontsource/dm-sans/600.css';
import './App.css';
import { AppProvider } from './components/AppContext';
import { ReactQueryProvider } from './providers/ReactQueryProvider';
import { GalleryStoreProvider } from './stores/useGalleryStore';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <AppProvider>
    <ReactQueryProvider>
      <GalleryStoreProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </GalleryStoreProvider>
    </ReactQueryProvider>
  </AppProvider>
);
